import { Component } from 'react';
import { withTranslation } from 'react-i18next';

import DataTable from '../../../../components/Datatable';
import Loading from '../../../../components/Loading';
import { contributorColumns } from '../../GscTools/columns';
import { reportsPosition } from '../../GscTools/metrics';
import { formatPeriod } from '../../GscTools/period';
import { getSortKeys, setAdditionalStyles } from '../../../../helpers/table';

/**
 * Block 03 — the pages that received impressions for the selected query.
 *
 * Nothing is requested until a query is opened, and what was fetched for a previous one is
 * discarded rather than left on screen under a new heading.
 *
 * These rows are evidence to inspect, not a verdict. A query served by two URLs is a fact about
 * what Search Console returned; it is not proof that the two competed, that either was harmed, or
 * that consolidating them would help. The response carries no title, no content and no ranking
 * history, so the block says what it has and stops there.
 */
class QueryPages extends Component {
    constructor(props) {
        super(props);
        this.searchFunction = this.searchFunction.bind(this);
    }

    searchFunction(data, search) {
        if (!search) return data;
        const term = search.toLowerCase();
        return data.filter((item) => item.key?.toLowerCase().includes(term));
    }

    render() {
        const { t, scope, status, error, rows, selectedQuery } = this.props;

        const columns = contributorColumns(t, {
            hasPosition: reportsPosition(scope.searchType),
            keyLabel: t('tools.gsc.columns.page'),
            isUrl: true,
        });

        return (
            <div className="card table-main rounded-main overflow-hidden gsc-tool-block">
                <div className="card-header d-flex justify-content-between">
                    <div>
                        <p className="card-title">{t('tools.search_opportunities.pages.title')}</p>
                        <p className="gsc-tool-sub">
                            {selectedQuery
                                ? `${selectedQuery} · ${formatPeriod(scope.current)}`
                                : t('tools.search_opportunities.pages.description')}
                        </p>
                    </div>
                </div>

                <div className="card-body">
                    {!selectedQuery && (
                        <div className="gsc-tool-load-state">
                            <span className="gsc-tool-load-icon" aria-hidden="true">
                                <i className="icon-fi_search" />
                            </span>
                            <h4>{t('tools.search_opportunities.pages.idle_title')}</h4>
                            <p>{t('tools.search_opportunities.pages.idle')}</p>
                        </div>
                    )}

                    {!!selectedQuery && status === 'loading' && <Loading padding={20} />}

                    {!!selectedQuery && status === 'error' && (
                        <div className="gsc-tool-banner error">
                            {error ?? t('global.something_went_wrong')}
                        </div>
                    )}

                    {!!selectedQuery && status === 'done' && (
                        <>
                            <DataTable
                                nodes={rows}
                                COLUMNS={columns}
                                sortFns={getSortKeys(columns)}
                                additionalStyles={setAdditionalStyles(columns)}
                                searchFunction={this.searchFunction}
                                fileName={t('tools.search_opportunities.pages.file')}
                                customEmptyMessage={t('tools.search_opportunities.pages.empty')}
                                customContainerStyles="gsc-tool-key-table"
                            />

                            <p className="gsc-tool-table-note">
                                {t('tools.search_opportunities.pages.evidence_note')}
                            </p>
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default withTranslation()(QueryPages);
